__turbopack_context__.v({
  "className": "planargt_f726148a-module__Locfuq__className",
  "variable": "planargt_f726148a-module__Locfuq__variable",
});
